<template>
  <div
    v-if="isPageLoadError"
    class="cf-page-content-container"
  >
    <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16">
      <span class="cf-icon cf-icon--brand-primary cf-icon--large far fa-exclamation-triangle" />

      <h2 class="cf-title cf-title--2">
        Something went wrong...
      </h2>
    </div>
  </div>

  <div v-else>
    <slot />
  </div>
</template>


<script>
  export default {
    name: 'ErrorPage',

    props: {
      isPageLoadError: {
        type: Boolean,
        required: true
      }
    }
  };
</script>
